"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const faExclamationTriangle_1 = require("@fortawesome/free-solid-svg-icons/faExclamationTriangle");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const FormErrors = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    if (props.errors && props.errors.length > 0) {
        return (react_1.default.createElement("div", { className: "apptr__form-errors-container" }, props.errors.map((errorMessage) => {
            const translatedText = typeof errorMessage === 'object' ? t(errorMessage.text, errorMessage.params) : t(errorMessage);
            return (react_1.default.createElement("p", { key: translatedText, className: `${props.errorType === 'Warning'
                    ? 'apptr__form-warning-message'
                    : 'apptr__form-error-message'} _strong` },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faExclamationTriangle_1.faExclamationTriangle, className: "_icon" }),
                translatedText));
        })));
    }
    else {
        return null;
    }
};
exports.default = FormErrors;
//# sourceMappingURL=FormErrors.js.map